import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ButtonLoading } from "go-form";
import ListImageName from "go-app/components/ImageRenderer/ListImageName";
import EmptyData from "go-core/components/EmptyData";
import { Loading } from "go-core/components/Loading";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { MenuItemApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	loading: boolean;
	itemButtonLoading?: number;
	hasMultipleChoice?: boolean;
	contextType: string;
	getCheckboxesValue: (item: MenuItemApi) => boolean;
	isItemAlreadySelected: (item: any) => boolean;
	selectNewMenuItems: (item: MenuItemApi) => void;
	getRouteName: (contextName: string) => string;
	menuItem: MenuItemApi;
	changeSelectedItem: (item: any) => void;
	tableItems: Record<string, any>[];
}

export const MenuPageItemModalTable = ({
	loading,
	itemButtonLoading,
	hasMultipleChoice,
	contextType,
	tableItems,
	getCheckboxesValue,
	isItemAlreadySelected,
	selectNewMenuItems,
	getRouteName,
	menuItem,
	changeSelectedItem,
}: Props) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);

	if (tableItems.length === 0) return <EmptyData />;

	const getItemId = (item: any) => {
		return contextType === "ITEM" ? item.item_group_id : item.id;
	};

	return (
		<div className="table-responsive">
			<table className="table">
				<tbody>
					<>
						{tableItems.map((responseItem: any, index: number) => {
							const itemId = getItemId(responseItem);

							return (
								<tr
									key={index}
									className={isItemAlreadySelected(responseItem) ? "table-primary" : undefined}
								>
									{(contextType === "ITEM" || contextType === "ITEM_GROUP") && hasMultipleChoice && (
										<td className="p-0 w-1">
											<label>
												<input
													type="checkbox"
													aria-label={`item-${index}`}
													className="me-2"
													checked={getCheckboxesValue(responseItem)}
													onClick={() => selectNewMenuItems(responseItem)}
												/>
											</label>
										</td>
									)}
									<td>
										<div className="d-flex align-items-center">
											<ListImageName
												imageLink={responseItem.image_link}
												data={responseItem}
												showColor={false}
											/>
											{itemId ? (
												<Link
													to={`/${organization.id}/menu/${getRouteName(
														contextType
													)}/${itemId}`}
													target={"_blank"}
													rel="noreferrer"
												>
													{responseItem.label}
												</Link>
											) : (
												<p className="mb-0">{responseItem.label}</p>
											)}
										</div>
									</td>
									<td>
										{itemButtonLoading !== undefined &&
										itemButtonLoading === Number(responseItem?.id) ? (
											<ButtonLoading
												loading={!!itemButtonLoading}
												className="float-end"
												variant={
													menuItem?.context_id === responseItem.id
														? "primary"
														: "primary-light"
												}
												type="button"
												onClick={() => changeSelectedItem(responseItem)}
											>
												{t("common.action.select", { ns: "lib" })}
											</ButtonLoading>
										) : (
											<Button
												className="float-end"
												variant={
													menuItem?.context_id === responseItem.id
														? "primary"
														: "primary-light"
												}
												type="button"
												onClick={() => changeSelectedItem(responseItem)}
											>
												{t("common.action.select", { ns: "lib" })}
											</Button>
										)}
									</td>
								</tr>
							);
						})}
						{loading && (
							<tr>
								<td colSpan={3}>
									<Loading />
								</td>
							</tr>
						)}
					</>
				</tbody>
			</table>
		</div>
	);
};
